import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { columnTitleMap } from './config'

import type { Column } from '@app/components/base/Table/types'

import type { ProductCardDrawerTableColumns, ProductCardDrawerTableColumnsKeys } from './types'
import type { DependentProductsDataSource } from '@app/types/dataSource'

const getOptions = (): Array<Column<ProductCardDrawerTableColumns>> => {
  const columnsKeys = Object.keys(columnTitleMap) as ProductCardDrawerTableColumnsKeys

  return columnsKeys.map(key => {
    const column: Column<ProductCardDrawerTableColumns> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<DependentProductsDataSource>> =>
  [
    ...getColumnsFromMap<ProductCardDrawerTableColumns>({
      columnTitleMap,
      options: getOptions()
    })
  ] as Array<Column<DependentProductsDataSource>>
